const isProd = process.env.NODE_ENV === "production";

module.exports = global.config = {
    ////////////////////////////////////////
    url: isProd
        ? {
              // Production: mặc định dùng URL tương đối -> tự chạy đúng trên
              // BẤT KỲ domain nào đã deploy, không cần build lại.
              // Nếu bạn cần domain API/client khác nhau (VD: api.domain.com),
              // chỉ cần set biến môi trường tương ứng, không cần sửa code.
              client: process.env.CLIENT_URL || "/",
              base: process.env.BASE_URL || "/",
              api: process.env.API_URL || "/api/",
          }
        : {
              // Local (khi NODE_ENV khác "production")
              client: process.env.CLIENT_URL || "http://localhost:3000/",
              base: process.env.BASE_URL || "http://localhost:8000/",
              api: process.env.API_URL || "http://localhost:8000/api/",
          },
    key: {
        app: "7yp!F4m78Qp@2tnV",
        encrypt: "jH@05GzMcT$6!",
        log: "HyLY@KwUS!2$$Nf8",
    },
    cates: {
        ////default config cate global
        tbl_cate_ethnic: [],
        tbl_cate_forms_training: [],
        tbl_cate_informatics_certificate: [],
        tbl_cate_language_certificate: [],
        tbl_cate_nationality: [],
        tbl_cate_organize: [],
        tbl_cate_position_party: [],
        tbl_cate_position_trade_union: [],
        tbl_cate_position_union: [],
        tbl_cate_religion: [],
        tbl_product_cate: [],
        dashboards: [],
        isOnline: "",
    },
};